var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19281 0.19635L4 3.00342L6.79265 0.210894C6.85433 0.145239 6.92864 0.0927167 7.01112 0.0564776C7.0936 0.0202384 7.18255 0.00102854 7.27263 0C7.46551 0 7.65049 0.0766176 7.78688 0.212998C7.92326 0.349378 7.99988 0.53435 7.99988 0.72722C8.00158 0.816379 7.98504 0.904944 7.95127 0.987479C7.9175 1.07001 7.86723 1.14478 7.80352 1.20719L4.97452 3.99971L7.80352 6.8286C7.92339 6.94586 7.99367 7.10464 7.99988 7.2722C7.99988 7.46508 7.92326 7.65005 7.78688 7.78643C7.65049 7.92281 7.46551 7.99943 7.27263 7.99943C7.17995 8.00327 7.08747 7.9878 7.00109 7.954C6.9147 7.9202 6.83629 7.8688 6.77083 7.80308L4 4.996L1.20008 7.7958C1.13863 7.85927 1.06522 7.90994 0.984091 7.94489C0.902957 7.97984 0.815705 7.99837 0.72737 7.99943C0.534491 7.99943 0.349511 7.92281 0.213125 7.78643C0.0767392 7.65005 0.000118329 7.46508 0.000118329 7.2722C-0.00157725 7.18305 0.0149655 7.09448 0.0487314 7.01195C0.0824973 6.92941 0.132774 6.85465 0.196476 6.79224L3.02548 3.99971L0.196476 1.17082C0.0766142 1.05357 0.00632878 0.894781 0.000118329 0.72722C0.000118329 0.53435 0.0767392 0.349378 0.213125 0.212998C0.349511 0.0766176 0.534491 0 0.72737 0C0.90191 0.00218166 1.06918 0.072722 1.19281 0.19635Z",
    fill: "#F9116C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.10cc5657abcdaa8a4adaf193de47882b.svg";
export { ForwardRef as ReactComponent };